import { createSelector } from '@ngrx/store';
import { getRoles } from 'src/app/shared/selectors/roles.selectors';
import { getDragonflyState } from '../reducers';

export const getTagAssignmentState = createSelector(
  getDragonflyState,
  (state) => state.tagAssignment
);

export const getPanelExpansion = createSelector(
  getTagAssignmentState,
  ({ panelExpanded }) => panelExpanded
);

export const getTagTypeSelectionValues = createSelector(
  getTagAssignmentState,
  ({ tagTypeValues }) => tagTypeValues
);

export const getTagType = createSelector(
  getTagAssignmentState,
  ({ tagType }) => tagType
);

export const getBrandCode = createSelector(
  getTagAssignmentState,
  ({ brandCode }) => brandCode
);

export const getSearchRole = createSelector(getRoles, (roles) =>
  Object.keys(roles).includes('tags.search')
);

export const getSearchButtonDisabled = createSelector(
  getTagType,
  getSearchRole,
  (tagType, searchRole) => (!tagType || searchRole === false ? true : false)
);
